import { useQuery } from "react-query";
import { getData } from "../newApis/apiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

export enum ChannelType {
  INTERNET_BANKING = 1,
  WEB = 2,
  MOBILE = 3,
}

type IParams = {
  bankCode: string;
  accountNumber: string;
  channelCode: ChannelType;
  isReveal: boolean;
};

const fetchProviderBalanceEnquiry = async ({
  bankCode,
  accountNumber,
  channelCode,
  isReveal,
}: IParams) => {
  let queryParams = `?bankCode=${bankCode}&accountNumber=${accountNumber}&channelCode=${channelCode}`;

  const response = await getData(
    `${ajaxEndpoints.FETCH_BANK_PROVIDER_ACCOUNT_BALANCE}${queryParams}`,
  );

  return response.data;
};

export const useFetchProviderBalanceEnquiry = (params: IParams) => {
  return useQuery(
    ["fetchProviderBalanceEnquiry", params.bankCode, params.accountNumber],
    () => fetchProviderBalanceEnquiry(params),
    {
      enabled:
        !!params.bankCode &&
        !!params.accountNumber &&
        !!params.channelCode &&
        params.isReveal,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60,
    },
  );
};
